module.exports = __webpack_public_path__ + "img/gallery12-1.1fa97f1e.jpg";